import { Spinner } from '@cian/ui-kit';

import { type FC } from 'react';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useIntersectionObserver } from '@/packages/react-utils/useIntersectionObserver';

import { InfinityLoaderArea } from '../../components/InfinityLoaderArea';

interface IInfinityLoaderAreaContainerProps {
  isActive: boolean;
  loading: boolean;
  onInViewport: VoidFunction;
}

export const InfinityLoaderAreaContainer: FC<IInfinityLoaderAreaContainerProps> = ({
  isActive,
  loading,
  onInViewport,
}) => {
  const { hasNextPage } = useSearchOffersDesktopQuery();

  const { elementRef } = useIntersectionObserver<HTMLDivElement>(
    {
      observerOptions: { threshold: 0.5 },
      onInViewport: () => {
        if (isActive) {
          onInViewport();
        }
      },
    },
    [isActive],
  );

  if (!hasNextPage) {
    return null;
  }

  return <InfinityLoaderArea ref={elementRef}>{(isActive || loading) && <Spinner size={44} />}</InfinityLoaderArea>;
};
